// store/slices/projectSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  projects: [],
  filteredProjects: [],
  categories: [],
  selectedCategory: 'All',
  searchQuery: '',
  loading: false,
  error: null,
};

// Async thunk for fetching projects
export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async () => {
    const response = await fetch('/api/projects');
    return await response.json();
  }
);

const projectSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
      state.filteredProjects = filterProjects(state.projects, state.selectedCategory, state.searchQuery);
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
      state.filteredProjects = filterProjects(state.projects, state.selectedCategory, action.payload);
    },
    filterProjects: (state) => {
      state.filteredProjects = filterProjects(state.projects, state.selectedCategory, state.searchQuery);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.projects = action.payload;
        state.filteredProjects = action.payload;
        state.categories = ['All', ...new Set(action.payload.map(p => p.category))];
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Helper function
const filterProjects = (projects, category, query) => {
  let filtered = projects;
  
  if (category !== 'All') {
    filtered = filtered.filter(project => project.category === category);
  }
  
  if (query.trim()) {
    const q = query.toLowerCase();
    filtered = filtered.filter(project => 
      project.title.toLowerCase().includes(q) ||
      project.description.toLowerCase().includes(q) ||
      project.tags.some(tag => tag.toLowerCase().includes(q)) ||
      project.technologies.some(tech => tech.toLowerCase().includes(q))
    );
  }
  
  return filtered;
};

export const { setSelectedCategory, setSearchQuery } = projectSlice.actions;
export default projectSlice.reducer;